module.exports = __webpack_public_path__ + "static/inkblot-logo-wordmark-8161debed3613d2a2bde6c1c31e30ef5.png";